import React from 'react';
import './Dashboard.css';

const PARAMETERS = [
  {
    title: 'Trust Score',
    desc: 'Indicates the overall trustworthiness of the communication (0–100%)',
    color: '#d9c98d',
  },
  {
    title: 'Detected Emotion',
    desc: 'Shows the dominant emotion extracted from voice/text',
    color: '#476281',
  },
  {
    title: 'Severity',
    desc: 'Classifies risk based on trust score and emotion (LOW, MEDIUM, HIGH)',
    color: '#74a49e',
  },
  {
    title: 'Timestamp',
    desc: 'Exact time of analysis. Useful for chronological tracking or audits.',
    color: '#b76c4a',
  },
  {
    title: 'Notes',
    desc: 'User’s raw message or summary of AI interpretation.',
    color: '#b9a8c4',
  },
  {
    title: 'Alerts',
    desc: 'Urgent flags triggered based on predefined emotion/keyword rules.',
    color: '#5b8697',
  },
];

const DashBoard = () => {
  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Analysis Parameter</h1>
        <p>Analyzing communication patterns and emotional context in real time</p>
      </div>

      <div className="parameter-grid">
        {PARAMETERS.map((param, index) => (
          <div
            key={index}
            className="parameter-card"
            style={{ backgroundColor: param.color }}
          >
            <h3>{param.title}</h3>
            <p>{param.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashBoard;
